/**  https://www.highlight.io/docs/getting-started/client-sdk/replay-configuration/privacy */

import { PropsWithChildren } from "react";

/** Applying this class to an element causes Highlight to scramble any contained text. */
export const SENSITIVE_CLASS_NAME = "highlight-mask";
/** Applying this class to an element causes Highlight to entirely black it out. */
export const BLOCK_CLASS_NAME = "highlight-block";
/** Applies {@link SENSITIVE_BY_CLASS_NAME}. */
export const SENSITIVE_BY_CLASS_NAME = { className: SENSITIVE_CLASS_NAME };
/** Applies {@link BLOCK_CLASS_NAME} */
export const BLOCK_BY_CLASS_NAME = { className: BLOCK_CLASS_NAME };
interface IProps {
    /** Blocks the contents from Highlight entirely, not just the text. */
    block?: boolean;
}
/** Conditionally applies {@link SENSITIVE_BY_CLASS_NAME} or {@link BLOCK_BY_CLASS_NAME}. */
export const maybeSensitive = (sensitive: boolean, { block }: IProps = {}) =>
    sensitive ? (block ? BLOCK_BY_CLASS_NAME : SENSITIVE_BY_CLASS_NAME) : undefined;
/** Scrambles all contained text for Highlight session recordings or, if block is true, blacks out the contents completely. */
export const SensitiveData: React.FC<PropsWithChildren & IProps> = ({ children, block }) => (
    <span className={block ? BLOCK_CLASS_NAME : SENSITIVE_CLASS_NAME}>{children}</span>
);
